import dynamic from 'next/dynamic';

const AboutPage = dynamic(() => import('../../js/pages/AboutPage'), {ssr: false});

export default AboutPage;
